class PolicyRelatedAccountContactsCtrl {
    constructor() {
        this.pageSize = 5;
    }
}

PolicyRelatedAccountContactsCtrl.$inject = ['$scope'];

export default PolicyRelatedAccountContactsCtrl;
